import script from "./PolicyService.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyService.vue?vue&type=script&setup=true&lang=js"

import "./PolicyService.vue?vue&type=style&index=0&id=00229430&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00229430"]])

export default __exports__